<template>
</template>

<script>
export default {
  name: 'RedirectToDashboard',
  props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken', 'queryID', 'queryParams', 'queryMeta', 'embedded', 'selected'],

  data() {
    return {
      parsedSetupToken:{}
    }
  },

  methods: {
    parseSetupToken() {
      let result = [];
      if (this.setupToken) {
        this.parsedSetupToken = this.setupToken
        this.parsedSetupToken = this.setupToken.replaceAll("\n", "")
        let token = this.parsedSetupToken.split(";")

        token.forEach((e) => {
          let option = e.split("=")
          let val = option[1]
          result[option[0]] = val
        })
      }
      return result
    }
  },

  async mounted() {
    if (this.selected[0]) {
      let mySetupToken = this.parseSetupToken()
      let paramFields = mySetupToken.ParameterList.split(",")

      let paramList = {}
      paramFields.forEach((param) => {
        paramList["qp." + param] = this.selected[0][param]
      })

      console.warn("Call Plugin 'RedirectToDashboard'.", mySetupToken, paramFields, paramList, this.selected[0])
      this.$router.push({
        name: 'Detail',
        params: {
          id: mySetupToken["CategoryID"]
        },
        query: paramList}).catch(err => {
      })
    }
  }
}

</script>

